export const carTypeOptions = [
	{ key: 'Hatchback', value: 'Hatchback' },
	{ key: 'Sedan', value: 'Sedan' },
	{ key: 'SUV', value: 'SUV' },
];
